<template>
  <div class="animated fadeIn">
    <b-card header="Search Filter">
      <b-form>
        <b-row>
          <b-col md="6" class="mb-3">
            <label for="status">Type</label>
            <b-form-select id="type" v-model="form.type" :options="typeOptions" name="type" />
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" class="mb-3">
            <label for="start-date">Start Date</label>
            <b-input-group>
              <b-input-group-prepend><b-input-group-text><i class="icon-calendar"/></b-input-group-text></b-input-group-prepend>
              <date-pick v-model="form.start_date" :display-format="'DD-MM-YYYY'" :input-attributes="{class:'form-control', id:'start-date', name:'start_date'}"/>
            </b-input-group>
          </b-col>
          <b-col md="6" class="mb-3">
            <label for="end-date">End Date</label>
            <b-input-group>
              <b-input-group-prepend><b-input-group-text><i class="icon-calendar"/></b-input-group-text></b-input-group-prepend>
              <date-pick v-model="form.end_date" :display-format="'DD-MM-YYYY'" :input-attributes="{class:'form-control', id:'end-date', name:'end_date'}"/>
            </b-input-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" class="mb-3">
            <label for="sort-by">Sort By</label>
            <b-form-select id="sort-by" v-model="form.sort_by" :options="sortOptions" name="sort_by" />
          </b-col>
          <b-col md="6" class="mb-3">
            <label for="per_page">Item per Page</label>
            <b-form-select id="per-page" v-model="form.per_page" :options="perPageOptions" name="per_page" />
          </b-col>
        </b-row>
        <b-button :disabled="storeState.isChildLoading" variant="primary" @click="handleSearchIncentive">Search</b-button>
      </b-form>
    </b-card>
    <b-card header="Incentives History">
      <b-table v-if="items" :items="items" :fields="fields" bordered hover responsive class="text-nowrap">
        <template slot="created_at" slot-scope="data">
          {{ data.item.created_at | formatTime }}
        </template>
        <template slot="amount" slot-scope="data">
          {{ data.item.amount | toRupiah }}
        </template>
        <template slot="saldo" slot-scope="data">
          {{ data.item.saldo | toRupiah }}
        </template>
      </b-table>
      <p v-if="!items" class="mb-0">No data</p>
      <b-pagination v-if="items && totalRows > params.per_page" :disabled="storeState.isChildLoading" :total-rows="totalRows" v-model="params.page" :per-page="params.per_page" align="center" first-text="First" prev-text="Prev" next-text="Next" last-text="Last" size="md" class="mt-4" @change="updateQueryString" />
    </b-card>
  </div>
</template>

<script>
import DatePick from 'vue-date-pick'
import { store } from '@/shared/store'
import { formatTime, toRupiah } from '@/shared/utils'
import { getIncentiveList, handleError } from '@/services/metal'

export default {
  name: 'IncentivesHistory',
  components: { DatePick },

  filters: {
    formatTime: function(val) {
      return formatTime(val)
    },
    toRupiah: function(val) {
      return toRupiah(val)
    }
  }, // filters

  data() {
    return {
      params: {},
      form: {},
      typeOptions: [
        { value: '', text: 'All' },
        { value: 'BUYBACK', text: 'Buyback' },
        { value: 'TRANSFER_INCENTIVE', text: 'Transfer Incentive' },
      ],
      sortOptions: [
        { value: 'date_desc', text: 'Newest date' },
        { value: 'date_asc', text: 'Oldest date' },
      ],
      perPageOptions: [
        { value: 10, text: '10' },
        { value: 25, text: '25' },
        { value: 50, text: '50' },
        { value: 75, text: '75' },
        { value: 100, text: '100' }
      ],
      fields: [
        {
          key: 'created_at',
          label: 'Date'
        },
        'amount',
        'status_amount',
        'type',
        'saldo',
      ],
      items: null,
      totalRows: 0,
      storeState: store.state,
    }
  }, // data

  watch: {
    '$route': function() {
      store.setIsChildLoading(true)
      this.handleGetIncentiveList()
    },
  }, // watch

  created() {
    store.setIsInitLoading(true)
    this.handleGetIncentiveList()
  }, // created

  methods: {
    handleGetIncentiveList() {
      store.setIsProcessing(true)

      // assign default value
      this.params = {
        page: 1,
        type: '',
        start_date: '',
        end_date: '',
        sort_by: 'date_desc',
        per_page: 10,
      }

      // overwrite value from query string
      if (Object.keys(this.$route.query).length > 0) {
        if (this.$route.query.page) {
          this.$route.query.page = parseInt(this.$route.query.page)
        }

        if (this.$route.query.per_page) {
          this.$route.query.per_page = parseInt(this.$route.query.per_page)
        }

        this.params = Object.assign(this.params, this.$route.query)
      }

      // overwrite form value
      this.form = Object.assign({}, this.params)

      let reqData = {
        status: this.params.type,
        start_date: this.params.start_date,
        end_date: this.params.end_date,
        sort_by: this.params.sort_by,
        offset: (this.params.page-1)*this.params.per_page,
        limit: this.params.per_page,
      }

      getIncentiveList(reqData)
        .then( response => {
          this.items = response.data.data.incentives
          this.totalRows = response.data.data.total_data
          store.setIsInitLoading(false)
        })
        .catch( error => {
          handleError(error)
        })
        .then( () => {
          store.clearProcessing()
        })
    },

    updateQueryString(page) {
      this.params.page = page
      this.$router.push({ path: '/incentives/incentives-history', query: this.params})
    },

    handleSearchIncentive() {
      // overwrite params value using form value
      this.params = Object.assign(this.params, this.form)
      this.updateQueryString(1)
    },
  }, // methods
}
</script>
